import { PasswordInput, Select, SelectItem, TextInput, Toggle } from "@carbon/react";
import { useState, useEffect, useCallback, useMemo } from "react";
import ClassSelector from "../../../Components/classSelector";
import { useLazyQuery, gql } from "@apollo/client";
import { useMutation } from "@apollo/client";
import { useNavigate } from "react-router-dom";
import { createSHA256Hash } from "../../../Utils/cryptoUtils";
const ALL_USERS_QUERY = gql`
    query AllUsers($userTypes: [String!]!, $search: String) {
      allUsers(userTypes: $userTypes, search: $search) {
          username
      }
    }
`;

export function CreateUser() {
      const [usernames, setUsernames] = useState([]);
      const [loadUsers, { data }] = useLazyQuery(ALL_USERS_QUERY, {
          fetchPolicy: 'cache-first'
      });

      useEffect(() => {
            loadUsers({ variables: { userTypes: [], search: "" } });
      }, []); // Removed loadUsers from dependencies to prevent loops

      useEffect(() => {
            if (data && data.allUsers) {
                  setUsernames(data.allUsers.map(u => u.username));
            }
      }, [data]);
    const CREATE_USER_MUTATION = gql`
        mutation CreateUser(
            $username: String!,
            $firstname: String!,
            $lastname: String!,
            $password: String!,
            $type: String!,
            $classId: String,
            $boarding: Boolean
        ) {
            createUser(
                username: $username,
                firstname: $firstname,
                lastname: $lastname,
                password: $password,
                type: $type,
                classId: $classId,
                boarding: $boarding
            ) {
                username
            }
        }
    `;


    const [createUser] = useMutation(CREATE_USER_MUTATION);
    const navigate = useNavigate();

    function handleSubmit(event) {
        event.preventDefault();
        createUser({
            variables: {
                username,
                firstname: surname,
                lastname,
                password: createSHA256Hash(password),
                type: userType,
                classId: userType === "student" ? selectedClass : null,
                boarding
            }
        }).then(() => {
            navigate("/admin/users");
        }).catch((err) => {
            setErrorMessage("Fehler beim Erstellen des Nutzers.");
        });
    }


      const [username, setUsername] = useState('');
      const [surname, setSurname] = useState('');
      const [lastname, setLastname] = useState('');
      const [password, setPassword] = useState('');
      const [confirmPassword, setConfirmPassword] = useState('');
      const [continueEnabled, setContinueEnabled] = useState(false);
      const [errorMessage, setErrorMessage] = useState('');
      const [userType, setUserType] = useState('student'); // Default to 'student'
      const [selectedClass, setSelectedClass] = useState(null);
      const [boarding, setBoarding] = useState(false);

      function validateForm() {
            if (username === '') {
                setErrorMessage('Benutzername ist erforderlich.');
                setContinueEnabled(false);
                return false;
            }
            if (usernames.includes(username)) {
                setErrorMessage('Benutzername muss eindeutig sein.');
                setContinueEnabled(false);
                return false;
            }
            if (surname === '') {
                setErrorMessage('Vorname ist erforderlich.');
                setContinueEnabled(false);
                return false;
            }
            if (lastname === '') {
                setErrorMessage('Nachname ist erforderlich.');
                setContinueEnabled(false);
                return false;
            }
            if (password === '') {
                setErrorMessage('Passwort ist erforderlich.');
                setContinueEnabled(false);
                return false;
            }
            if (password !== confirmPassword) {
                setErrorMessage('Passwörter stimmen nicht überein.');
                setContinueEnabled(false);
                return false;
            }
            if (userType === 'student' && !selectedClass) {
                setErrorMessage('Bitte wähle eine Klasse aus.');
                setContinueEnabled(false);
                return false;
            }
            setErrorMessage('');
            setContinueEnabled(true);
            return true;
      }

      useEffect(() => {
            validateForm();
      }, [username, surname, lastname, password, confirmPassword, userType, selectedClass]);

      return (
            <div className="py-4">
                  <div className="max-w-2xl">
                        <h1 className="text-2xl font-bold text-gray-900">
                              Nutzer erstellen
                        </h1>
                        <form onSubmit={handleSubmit} className="mt-8 space-y-6">
                              <TextInput
                                    id="username"
                                    labelText="Benutzername"
                                    placeholder="zum Beispiel: dikoma15 (muss eindeutig sein)"
                                    className="w-full"
                                    value={username}
                                    onChange={(e) => setUsername(e.target.value)}
                                    required
                              />
                              <TextInput
                                    id="surname"
                                    labelText="Vorname"
                                    placeholder="Vorname eingeben (z.B. Maxim)"
                                    className="w-full"
                                    value={surname}
                                    onChange={(e) => setSurname(e.target.value)}
                                    required
                              />
                              <TextInput
                                    id="lastname"
                                    labelText="Nachname"
                                    placeholder="Nachname eingeben (z.B. Dikov)"
                                    className="w-full"
                                    value={lastname}
                                    onChange={(e) => setLastname(e.target.value)}
                                    required
                              />
                              <PasswordInput
                                    id="password"
                                    labelText="Passwort"
                                    placeholder="Passwort eingeben"
                                    className="w-full"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    required
                              />
                              <PasswordInput
                                    id="confirmPassword"
                                    labelText="Passwort bestätigen"
                                    placeholder="Passwort erneut eingeben"
                                    className="w-full"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                              />
                              <Select
                                    id="userType"
                                    labelText="Benutzertyp"
                                    value={userType}
                                    onChange={(e) => setUserType(e.target.value)}
                                    className="w-full"
                              >
                                    <SelectItem value="student" text="Schüler" />
                                    <SelectItem value="teacher" text="Lehrer" />
                                    <SelectItem value="admin" text="Administrator" />
                              </Select>
                              {(userType === 'student') && (
                                    <ClassSelector
                                          selectedClass={selectedClass}
                                          onClassChange={setSelectedClass}
                                          enableAllClasses={false}
                                    />
                              )}
                              {userType === 'student' && (
                                    <Toggle
                                          id="toggle-boarding-student"
                                          labelText="Vollintern"
                                          labelA={null}
                                          labelB={null}
                                          toggled={boarding}
                                          onToggle={(toggled) => setBoarding(toggled)}
                                    />
                              )}
                              {userType === 'teacher' && (
                                    <Toggle
                                          id="toggle-boarding-teacher"
                                          labelText="Erzieher"
                                          labelA={null}
                                          labelB={null}
                                          toggled={boarding}
                                          onToggle={(toggled) => setBoarding(toggled)}
                                    />
                              )}

                              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 pt-4">
                                    <p className="text-sm text-red-600 h-5">
                                          {errorMessage}
                                    </p>
                                    <button
                                          type="submit"
                                          className={`mainBtn w-full sm:w-auto text-white px-6 py-2 transition-opacity duration-200 ${
                                                continueEnabled ? 'hover:bg-blue-700' : 'opacity-50 cursor-not-allowed'
                                          }`}
                                          disabled={!continueEnabled}
                                    >
                                          Nutzer erstellen
                                    </button>
                              </div>
                        </form>
                  </div>
            </div>
      );
}